export const selectCSOData = (state) => state.csoReport.csodata;
